import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { SubscriptionPlanCSSStyle, SubscriptionPlanCSSStyleImpl } from '../subscription_plan/subscriptionplancss';

export interface UpgradePackCSSStyle extends SubscriptionPlanCSSStyle{
    
    getHeaderDivCSSStyle(): object ;
    getTitleCSSStyle(): object ;
    getCloseIconDivCSSStyle(): object ;
    getCloseIconCSSStyle(): object ;
    getSubscriptionCircleDivCSSStyle(isHovered:boolean):object;
    getMobileSubscriptionCircleDivCSSStyle(isHovered:boolean):object;
    getSubscriptionDetailsDivCSSStyle():object;
    getMobileSubscriptionDetailsDivCSSStyle():object;
    getMobileWrapperCSSStyle():object;
    getMobileTitleCSSStyle(): object;
    getAnchorCSSStyle(): object;
    getTermsConditionCSSStyle(): object;
    getRowDivCSSStyle(): object ;

}
export class UpgradePackCSSStyleImpl extends SubscriptionPlanCSSStyleImpl
{
    getWrapperCSSStyle(): object
    {
        return {
            width: "584px",
            height: "auto",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            borderRadius: "8px",
            flexFlow: "row wrap",
            position:'relative',
            objectFit:'fill',
            justifyContent:'center',
            itemAlign:'center',
            paddingBottom:'30px'
        };
    }

    getMobileWrapperCSSStyle():object{
        return{
            width: "100%",
            height: "auto",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            borderRadius: "8px",
            flexFlow: "row wrap",
            position:'relative',
            objectFit:'fill',
            justifyContent:'center',
            itemAlign:'center',
            paddingBottom:'30px'
        };
    }

    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getTitleCSSStyle(): object {
        return {
            width: "90%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft:"100px",
            paddingRight:"60px",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center",
        };
    }

    getMobileTitleCSSStyle(): object {
        return {
            width: "90%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "35px" : "0px",
            paddingRight:"0px",
            fontSize: "18px",
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center",
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

    getSubscriptionCircleDivCSSStyle(isHovered:boolean):object
    {
        return{
            width:'157px',
            marginRight:'20.56px',
            height:'157px',
            cursor: "pointer",
            borderRadius:'50%',
            backgroundColor: isHovered?"#003187":'#B3B3B3',
            color:isHovered?'#FFFFFF':'#000000'
        };
    }

    
    getMobileSubscriptionCircleDivCSSStyle(isHovered:boolean):object
    {
        return{
            width:'100px',
            marginRight:'12px',
            height:'100px',
            cursor: "pointer",
            borderRadius:'50%',
            backgroundColor: isHovered?"#003187":'#B3B3B3',
            color:isHovered?'#FFFFFF':'#000000'
        };
    }

    getSubscriptionDetailsDivCSSStyle():object
    {
        return{
            width:'100%',
            fontWeight:900,
            marginTop:'40px',
            height:'58px',
            textAlign:'center',
            lineHeight:'59px',
            fontSize:'48px',
        };
    }

    getMobileSubscriptionDetailsDivCSSStyle():object
    {
        return{
            width:'100%',
            fontWeight:900,
            marginTop:'27px',
            height:'25px',
            textAlign:'center',
            lineHeight:'25px',
            fontSize:'20px',
        };
    }
    getAnchorCSSStyle(): object {
        return {
                    lineHeight: '20px', 
                    letterSpacing: "-0.08px",
                    fontFamily: this.getResources().getFontFamily(), 
                    fontSize: this.getResources().getFont(Fonts.h6), 
                    color: this.getResources().getColor(Colors.color_7), 
                };
    }
    getTermsConditionCSSStyle(): object {
        return{
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:'#231F20',
            fontWeight:'500',
            fontFamily:this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            // flex: 2,
            // paddingTop:'5px',
            // marginLeft:'5px',
        };
    }
    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "20px",
            display: "flex",
            width:'100%',
            justifyContent:'center',
            position: "relative",
            alignItems:'center',
            flexDirection:"row",
            flexFlow: "row wrap",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/upgrade_pack/upgradepackcss.tsx